const logger = (param) => (store) => (next) => (action) => {
  // console.log("Logging", param);
  // Return the result so the dispatch chain preserves the promise the downstream
  // (api) middleware returns — callers rely on `dispatch(apiCallBegan(...)).then(...)`.
  return next(action)
}

export default logger
